<template>
    <div id="preview">
        <div id="heasers">
            <div class="header-wrap">
                <div class="header">
                    <span class="left"
                          @click="goBack"><i class="icon-fanhui"></i></span>
                    <div class="ellipsis">习题预览</div>
                    <slot></slot>
                </div>
            </div>
        </div>
        <noResouse v-if='noResouse'></noResouse>
        <div v-if="loading">
            <div class="itemLength">共{{totalNum}}题<span v-if="type==0&&isNew==1">（{{starTitle}}）</span></div>
            <div class="questions">
                <div class="question"
                     v-for="(item,qindex) in questions">
                    <i class="dge"
                       v-if='item.published'></i> <!--  发布标识 0 代表没有发过   1 发过 -->
                    <div class="quest_title"
                         v-if="item.subject.content||item.subject.image">
                        <p v-if="item.subject.content!=''"
                           v-html='item.subject.content'></p>
                        <img :src="item.subject.image"
                             v-if="item.subject.image!=''">
                    </div>
                    <div v-for="ask,inx in item.asks">
                        <!-- 选择题 -->
                        <div class="chooseti"
                             v-if="ask.display_type==1">
                            <choice :question='ask'
                                    :askLength='item.asks.length'></choice>
                        </div>
                        <!-- 填空 -->
                        <div v-if='ask.display_type == 2'>
                            <blanks :question='ask'
                                    :askLength='item.asks.length'></blanks>
                        </div>
                        <!-- 主观题 -->
                        <div v-if='ask.display_type == 3'>
                            <subjective :ask='item.asks'
                                        :index='inx'
                                        :question='ask'
                                        :askLength='item.asks.length'></subjective>
                        </div>
                        <!-- 连线题 -->
                        <div class="line"
                             v-if="ask.display_type==4">
                            <line-component :ask='ask'
                                            :sheet="ask.right_answer"
                                            :onlyshow='true'
                                            :askLength='item.asks.length'></line-component>
                        </div>
                    </div>
                    <div class="ask_bottom clearfix">
                        <span class="wrong_rate">使用次数：{{item.send_num}}次</span>
                        <span class="dele"
                              v-if="type!=0 && !item.choose"
                              @click="dele(item,qindex)">移除</span>
                        <span class="join"
                              v-if="type!=0 && item.choose"
                              @click="join(item,qindex)">加入</span>
                        <span class="star"
                              v-if="type==0&&isNew==1">
                            <i :class="{'gray':item.star<1}"></i>
                            <i :class="{'gray':item.star<2}"></i>
                            <i :class="{'gray':item.star<3}"></i>
                            <i :class="{'gray':item.star<4}"></i>
                            <i :class="{'gray':item.star<5}"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="bottom_btn clearfix"
                 v-if="type==1 && !noResouse">
                <div class="left_btn"
                     :class="typeOf!=1?'danClass':''"><i></i><span>已选（{{chooseNum}}题）</span></div>
                <div v-if='chooseNum==0'
                     :class="['right_btn',{'able':chooseNum>0,'disable':chooseNum==0}]">去发布</div>
                <div v-else
                     :class="['right_btn',{'able':chooseNum>0,'disable':chooseNum==0}]"
                     @click='send'>去发布</div>
                <div class="right_btn optional_btn"
                     v-if="typeOf==1"
                     @click="handleOptional">自己选题</div>
            </div>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import line from 'VIEWS/math/module/line.vue';
import choice from 'VIEWS/math/module/choice.vue'; //选择题
import blanks from 'VIEWS/math/module/blanks.vue';  //填空题
import subjective from 'VIEWS/math/module/subjective.vue';  //主观题
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';

export default {
    data () {
        return {
            titles: '',
            type: this.$route.params.type,//0单个预览，1全部预览
            id: this.$route.query.id,
            title: this.$route.query.title,
            typeOf: this.$route.query.typeOf, //2同步习题 3单元复习
            isNew: this.$route.query.is_new,//是否是新试卷
            questions: [],
            loading: false,
            sid: this.$route.params.sid,
            noResouse: false,
            totalNum: 0,  //总题
            chooseNum:0,
            qus_id: [],   //发布需要一个cid
            starTitle: '',
            isHD_schoolopen: this.$route.query.schoolopen || 0,//开学大检查活动
            optionData: JSON.parse(localStorage.getItem('activeData')),//自选题
        }
    },
    async created () {
        let math_send_ok = localStorage.getItem('math_send_ok');
        if (math_send_ok == 1) {
            this.$router.go(-1);
            return false;
        }
        // 可能是全部的试题预览  或者是单个预览
        //0单个预览  this.exercisesid  ，1全部预览  this.id
        this.titles = this.type == 0 ? this.title : '习题预览'
        let exerdata = this.$store.state.math.chapterid.join(',')
        // 全部预览 需要新的id
        await this.$http.post(API_URL_TASK_API + '/maths/send/general/paper/qid', {
            paper_id: exerdata,
            sid: this.sid
        }).then(res => {
            if (res.data.response === 'ok') {
                if (res.data.data.length) {
                    this.qus_id = res.data.data.join(',')
                }
            }
        });
        let _data = { qid: this.qus_id, sid: this.sid };
        if (this.sid == '21' && this.type == 0) {
            _data.paper_id = this.id;
        }
        await this.$http.post(API_URL_TASK_API + '/maths/questions', _data).then(res => {
            if (res.data.response === 'ok') {
                let filter_qids = []
                res.data.data.forEach(e => {
                    filter_qids.push(e.id)
                })
                localStorage.setItem('filter_qids', JSON.stringify(filter_qids))
                this.loading = true;
                if (res.data.data.length) {
                    if (this.optionData) {
                        this.questions = this.questions.concat(this.optionData);
                        this.questions = this.questions.concat(res.data.data);

                    } else {
                        this.questions = res.data.data;
                    }
                    let star1 = 0,
                        star2 = 0,
                        star3 = 0,
                        star4 = 0,
                        star5 = 0;

                    this.questions.forEach((m, n) => {
                        this.totalNum += m.asks.length;
                        if(!m.published){
                            m.choose = false;
                            this.chooseNum += m.asks.length;
                        }else{
                            m.choose = true;
                        }
                        if (this.sid == '21' && this.type == 0 && this.isNew == 1) {
                            if (m.star == 1) {
                                star1 += m.asks.length;
                            } else if (m.star == 2) {
                                star2 += m.asks.length;
                            } else if (m.star == 3) {
                                star3 += m.asks.length;
                            } else if (m.star == 4) {
                                star4 += m.asks.length;
                            } else {
                                star5 += m.asks.length;
                            }
                        }

                    });

                    // 其中一星题占10%，二星题占40%，三星题占30%，四星题占15%，五星题占5%
                    star1 = star1 == 0 ? 0 : Math.round(star1 / this.totalNum * 100);
                    star2 = star2 == 0 ? 0 : Math.round(star2 / this.totalNum * 100);
                    star3 = star3 == 0 ? 0 : Math.round(star3 / this.totalNum * 100);
                    star4 = star4 == 0 ? 0 : Math.round(star4 / this.totalNum * 100);
                    star5 = star5 == 0 ? 0 : Math.round(star5 / this.totalNum * 100);
                    // //console.log(star1,star2,star3,star4,star5)
                    this.starTitle = "其中一星题占" + star1 + "%，二星题占" + star2 + "%，三星题占" + star3 + "%，四星题占" + star4 + "%，五星题占" + star5 + "%。";
                } else {
                    this.noResouse = true
                }
            }

            this.$nextTick(function () {
                MathJax.Hub.Typeset(document.body)
            })
        })
    },
    computed: {
        screenid () {
            if (this.type) {
                return this.$store.state.math.screenid.join(',')
            }
        },
    },
    components: {
        headers,
        'line-component': line,
        subjective,
        loadingS,
        blanks,
        choice,
        noResouse,
    },
    methods: {
        dele (qid, index) {
            let len = qid.asks.length;
            this.chooseNum -= len;
            qid.choose = !qid.choose;
            this.questions.splice(index, 1, qid);
            if (this.optionData) {
                this.optionData.forEach((j, index) => {
                    if (j.id === qid.id) {
                        console.log(j)
                        j.choose = true
                    }
                })
            }


        },
        join (qid, index) {
            // if (this.chooseNum > 30) {
            //   layer.tips('已经超出30道题，不能再添加试题了');
            //   return false
            // }
            if (this.sid == 21) {
                if (this.chooseNum > 100) {
                    layer.tips('已经超出100道题，不能再添加试题了');
                    return false
                }
            } else if (this.sid == 22) {
                if (this.chooseNum > 50) {
                    layer.tips('已经超出50道题，不能再添加试题了');
                    return false
                }
            }
            let len = qid.asks.length;
            this.chooseNum += len;
            qid.choose = !qid.choose;
            this.questions.splice(index, 1, qid);
        },
        send () {
            // if (this.chooseNum > 30) {
            //   layer.tips('已经超出30道题，无法发布');
            //   return false
            // }
            if (this.sid == 21) {
                if (this.chooseNum > 100) {
                    layer.tips('已经超出100道题，无法发布');
                    return false
                }
            } else if (this.sid == 22) {
                if (this.chooseNum > 50) {
                    layer.tips('已经超出50道题，无法发布');
                    return false
                }
            }
            let that = this;
            let details = [];
            if (typeof this.qus_id == "string") { this.qus_id = this.qus_id.split(',') };
            this.questions.forEach((m, n) => {
                if (!m.choose) {
                    let obj = {};
                    obj.qid = m.id;
                    obj.cid = m.id;
                    details.push(obj)
                }
            });

            this.$store.commit('setreleaseid', details);
            this.$router.push('/sx/release/' + this.sid + '/' + this.typeOf)
            localStorage.removeItem('activeData')
            localStorage.removeItem('activeIds')
            localStorage.removeItem('filter_qids')
        },
        //自选题
        handleOptional () {
            if (this.optionData) {
                let activeIds = []
                this.optionData.forEach(e => {
                    if (!e.choose) {
                        activeIds.push(e.id)
                    }
                })
                localStorage.setItem('activeIds', JSON.stringify(activeIds))
            }
            this.$router.replace('/sx/testPaper/taskselect/' + this.sid + '/' + this.type + '?typeOf=' + this.$route.query.typeOf)
        },
        goBack () {
            this.$router.replace('/sx/testPaper/taskset/21/' + this.$route.query.typeOf)
        }
    },
    beforeDestroy () {
        localStorage.removeItem('schoolopenQid')
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#preview {
    padding-bottom: 100px / $ppr;
}

.question {
    margin-bottom: 25px / $ppr;
    position: relative;
    .dge {
        width: 100px / $ppr;
        height: 56px / $ppr;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 6;
        background: url("./img/icon_to.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
}

.quest_title {
    padding: 25px / $ppr;
    line-height: 46px / $ppr;
    font-size: 30px / $ppr;
    color: #333;
    border-bottom: 1px / $ppr solid #e8e8e8;
    background: #fff;
}

.itemLength {
    font-size: 30px / $ppr;
    font-weight: bold;
    padding: 0.6rem;
    line-height: 1.2rem;
    background: #fff;
    margin-bottom: 25px / $ppr;
    span {
        font-weight: normal;
    }
}

.ask_bottom {
    line-height: 96px / $ppr;
    height: 96px / $ppr;
    background: #fff;
    padding: 0 25px / $ppr;
    .wrong_rate {
        color: #999;
        font-size: 24px / $ppr;
        float: left;
    }
    .dele {
        float: right;
        width: 122px / $ppr;
        line-height: 48px / $ppr;
        height: 48px / $ppr;
        border: 1px / $ppr solid #ff6600;
        color: #ff6600;
        margin-top: 21px / $ppr;
        font-size: 26px / $ppr;
        text-align: center;
        border-radius: 28px / $ppr;
    }
    .join {
        float: right;
        width: 122px / $ppr;
        line-height: 48px / $ppr;
        height: 48px / $ppr;
        border: 1px / $ppr solid #5e89ef;
        color: #5e89ef;
        margin-top: 21px / $ppr;
        font-size: 28px / $ppr;
        text-align: center;
        border-radius: 24px / $ppr;
    }
    .star {
        float: right;
        height: 96px / $ppr;
        i {
            width: 32px / $ppr;
            height: 30px / $ppr;
            background: url("./img/icon3.png");
            background-size: 100% 100%;
            display: inline-block;
            vertical-align: middle;
        }
        .gray {
            background: url("./img/icon2.png");
            background-size: 100% 100%;
        }
    }
}

.line {
    background: #fff;
}

.bottom_btn {
    width: 100%;
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 7;
    font-size: 30px / $ppr;
    text-align: center;
    .left_btn {
        width: 48%;
        float: left;
        background: #f0f0f0;
        color: #333;
        position: relative;
        i {
            position: absolute;
            z-index: 1;
            top: 25px / $ppr;
            display: inline-block;
            width: 50px / $ppr;
            height: 42px / $ppr;
            background: url("./img/icon1.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
        span {
            display: inline-block;
            padding-left: 60px / $ppr;
        }
    }
    .right_btn {
        width: 26%;
        float: right;
    }
    .able {
        color: #fff;
        background: #5e89ef;
    }
    .disable {
        color: #999;
        background: #ccc;
    }
    .optional_btn {
        color: #fff;
        background: #66cc22;
    }
    .danClass {
        width: 74%;
    }
}
.header-wrap .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 8;
    height: $h-header;
    line-height: $h-header;
    color: #fff;
    font-size: 34px / $ppr;
    text-align: center;
    background: #5e89ef;
    .icon-fanhui {
        display: block;
        width: 76px / $ppr;
        height: $h-header;
        background-image: url("./img/back.png");
        background-position: center;
        background-size: 18px / $ppr 34px / $ppr;
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
    }
    .ellipsis {
        width: 520px / $ppr;
        margin: 0 auto;
    }
}
</style>
